export default __webpack_public_path__ + "static/media/284.432a980a.jpg";